import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import {
  PredictiveCRMNewFeaturePromotion,
  PredictiveCRMPopUp,
} from 'Modules/predictive-crm/components';
import DisclaimersTeleporter from '../../teleporters/DisclaimersTeleporter';

interface Props {
  children?: ReactNode;
}

function FullScreen({ children }: Props) {
  return (
    <main id="mainContent">
      <DisclaimersTeleporter.Target />
      {children ?? <Outlet />}
      <PredictiveCRMNewFeaturePromotion />
      <PredictiveCRMPopUp />
    </main>
  );
}

export default FullScreen;
